import { z } from "zod";

export const LiCompanyActivityEntrySchema = z.object({
	id: z.number(),
	liCompanyActivityId: z.number(),
	url: z.string(),
});

export type LiCompanyActivityEntry = z.infer<typeof LiCompanyActivityEntrySchema>;
